import OutlinedFloatingLabelInputMixin from '../mixins/outlined-floating-label-input-mixin.js';
import TpSelectBase from './tp-select-base.js';

class TpSelectOutlined extends 
  OutlinedFloatingLabelInputMixin(
    TpSelectBase
  ) {}

export default TpSelectOutlined;
